




























import { defineComponent } from "@vue/composition-api";
import { InputJoinData } from "@scrile/api-provider/dist/api/LoginProvider";
import { getFirstPart } from "@/lib/emailHelpers";
import { $t } from "@/lib/i18nHelpers";
import { loginSignUp } from "@/lib/loginHelpers";
import config from "@/config";
import { FormFields, FormValues, Tab } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import BaseSegmentedButton from "@/components/BaseSegmentedButton";
import LoginContainer from "@/components/LoginContainer";
import LoginPhone from "@/components/LoginPhone";

export default defineComponent({
  name: "SignUpComponent",
  components: { BaseSegmentedButton, BaseForm, BaseButton, LoginContainer, LoginPhone },
  props: {
    modalView: { type: Boolean, default: false },
    referralId: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      isValid: false,
      activeTab: "member",
      tabs: [
        { text: $t("Member"), value: "member" },
        { text: $t("Creator"), value: "creator" },
      ] as Tab[],
      fields: [
        {
          name: "email",
          label: $t("Email"),
          autocomplete: "email",
          type: "email",
          rules: "required",
        },
        {
          name: "password",
          type: "password",
          label: $t("Password"),
          autocomplete: "new-password",
          rules: ["required", "min:3"],
        },
      ] as FormFields,
      values: {} as FormValues,
    };
  },
  computed: {
    signUpByPhone(): boolean {
      return config.featurePhoneSignUp;
    },
    isSoloCreator(): boolean {
      return !!config.soloCreatorId;
    },
  },
  methods: {
    async submit() {
      if (!this.isValid) return;
      let { email, password } = this.values;
      try {
        this.loading = true;
        const data: InputJoinData = {
          email,
          password,
          role: config.userRegistrationRole,
          screenName: getFirstPart(email),
        };
        await loginSignUp(data, this.referralId);
        this.$emit("signup");
      } finally {
        this.loading = false;
      }
    },
    switchTab(value: string) {
      this.activeTab = value;
      this.$emit("switchTab", value);
    },
  },
});
